module.exports = __webpack_public_path__ + "static/media/Andorra - AD.cab73ff9.png";